<template>
  <div class="uk-container" v-if="loaded">
    <vk-breadcrumb>
      <vk-breadcrumb-item href="/administration">Union Member List</vk-breadcrumb-item>
      <vk-breadcrumb-item>Union Member Details</vk-breadcrumb-item>
    </vk-breadcrumb>
    <h1>{{this.member.fName + " " + this.member.lName}}
      <router-link class="uk-margin-small-right" :to="'/administration/members/' + this.member.bookNum + '/edit'" v-vk-tooltip.bottom="'Edit Member'"><vk-icon icon="pencil" ratio="1"></vk-icon></router-link>
      <a class="uk-margin-small-right" v-on:click="showResetModal = true"><vk-icon icon="refresh" ratio="1" v-vk-tooltip.bottom="'Reset Member'"></vk-icon></a>
      <a v-vk-tooltip.bottom="'Delete Member'"><vk-icon icon="minus-circle" ratio="1" v-on:click="showDeleteModal = true"></vk-icon></a>
    </h1>
    <h4 class="uk-text-bold">Phone #: {{this.member.phoneNumber}}</h4>
    <h4 class="uk-text-bold">Book #: {{this.member.bookNum}}</h4>
    <p>Currently Booked? {{(this.member.booked) ? "Yes" : "No"}}</p>
    <p>Member has {{this.member.refusals.length}} Refusal(s) and {{this.member.absences.length}} Absence(s)</p>
    <h4 class="uk-text-bold">Classifications</h4>
    <ul>
      <li v-for="(classification,index) in this.member.classifications" v-bind:key="index">
        {{classification}}
      </li>
    </ul>
    <h4 class="uk-text-bold">Certifications</h4>
    <ul>
      <li v-for="(certification,index) in this.member.certifications" v-bind:key="index">
        {{certification}}
      </li>
    </ul>
    <h4 class="uk-text-bold">Bookings</h4>
    <ul>
      <li v-for="booking in this.member.bookings" v-bind:key="booking.id">
        <router-link :to="'/administration/associations/bookings/' + booking.id + '/info'">{{formatDate(booking.date)}}</router-link> - {{booking.description}} <span v-if="booking.currentlyEmployed" class='uk-badge'>Currently Employed</span>
      </li>
    </ul>
    <router-link :to="'/administration/associations/bookings/create?booknum=' + this.member.bookNum"><vk-icon class="uk-margin-small-right plus" icon="plus-circle" ratio="1"></vk-icon>Add a Booking</router-link>
    <h4 class="uk-text-bold">Refusals</h4>
    <ul>
      <li v-for="refusal in this.member.refusals" v-bind:key="refusal.id">
        <router-link :to="'/administration/associations/refusals/' + refusal.id + '/info'">{{formatDate(refusal.date)}}</router-link> - {{refusal.description}}
      </li>
    </ul>
    <router-link :to="'/administration/associations/refusals/create?booknum=' + this.member.bookNum"><vk-icon class="uk-margin-small-right plus" icon="plus-circle" ratio="1"></vk-icon>Add a Refusal</router-link>
    <h4 class="uk-text-bold">Absences</h4>
    <ul>
      <li v-for="absence in this.member.absences" v-bind:key="absence.id">
        <router-link :to="'/administration/associations/absences/' + absence.id + '/info'">{{formatDate(absence.date)}}</router-link> - {{absence.description}}
      </li>
    </ul>
    <router-link :to="'/administration/associations/absences/create?booknum=' + this.member.bookNum"><vk-icon class="uk-margin-small-right plus" icon="plus-circle" ratio="1"></vk-icon>Add an Absence</router-link>
    <h4 class="uk-text-bold">Remarks</h4>
    <ul>
      <li v-for="remark in this.member.remarks" v-bind:key="remark.id">
        <router-link :to="'/administration/associations/remarks/' + remark.id + '/info'">{{formatDate(remark.date)}}</router-link> - {{remark.description}}
      </li>
    </ul>
    <router-link :to="'/administration/associations/remarks/create?booknum=' + this.member.bookNum"><vk-icon class="uk-margin-small-right plus" icon="plus-circle" ratio="1"></vk-icon>Add a Remark</router-link>
    <vk-modal :show.sync="showResetModal">
      <vk-modal-title>Are you sure you want to reset {{member.fName + " " + member.lName}}?</vk-modal-title>
      <p class="uk-text-right">
        <vk-button @click="showResetModal = false" class="uk-margin-small-right">Cancel</vk-button>
        <vk-button type="primary" @click="resetMember">Reset</vk-button>
      </p>
    </vk-modal>
    <vk-modal :show.sync="showDeleteModal">
      <vk-modal-title>Are you sure you want to delete {{member.fName + " " + member.lName}}?</vk-modal-title>
      <p class="uk-text-right">
        <vk-button @click="showDeleteModal = false" class="uk-margin-small-right">Cancel</vk-button>
        <vk-button type="primary" @click="deleteMember">Delete</vk-button>
      </p>
    </vk-modal>
  </div>
</template>

<script>
import MembersApi from "@/utils/api/members";

export default {
  name: "MemberInfo",
  data() {
    return {
      bookNum: this.$route.params.booknum,
      loaded: false,
      member: null,
      showResetModal: false,
      showDeleteModal: false,
      prevPath: null
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => (vm.prevPath = from.fullPath));
  },
  created() {
    MembersApi.getMember(this.$cookie.get("iwl_apiToken"), this.bookNum)
      .then(res => {
        this.member = res;
        this.loaded = true;
      })
      .catch(err => console.log(err));
  },
  methods: {
    refresh() {
      MembersApi.getMember(this.$cookie.get("iwl_apiToken"), this.bookNum)
        .then(res => {
          this.member = res;
        })
        .catch(err => console.log(err));
    },
    formatDate(date) {
      var d = new Date(date);
      return d.toLocaleDateString("en-US", {
        month: "numeric",
        day: "numeric",
        year: "2-digit",
        hour: "numeric",
        minute: "numeric"
      });
    },
    resetMember() {
      MembersApi.resetMember(
        this.$cookie.get("iwl_apiToken"),
        this.member.bookNum
      )
        .then(member => {
          this.refresh();
          this.showResetModal = false;
        })
        .catch(error => console.log(error));
    },
    deleteMember() {
      MembersApi.deleteMember(
        this.$cookie.get("iwl_apiToken"),
        this.member.bookNum
      )
        .then(member => {
          this.showDeleteModal = false;
          this.$router.push(this.prevPath);
        })
        .catch(error => console.log(error));
    }
  }
};
</script>

<style scoped>
ul {
  list-style: none;
  padding-left: 0px;
}
h4 {
  margin-bottom: 0px;
}
.plus {
  position: relative;
  top: -2px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin_member_info.vue